/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import * as Icon from "react-icons/md";
import {
  Overlay,
  Sheet,
  DragHandle,
  SheetTitle,
  SheetTag,
  InfoRow,
  InfoIconBox,
  InfoLabel,
  InfoValue,
  InfoSub,
  WeekdayGrid,
  WeekdayBadge,
  CenterRouteBtn,
} from "./styled";

const ModalInfo = (props, { id = "modal", onClose = () => {} }) => {
  const handleOutsideClick = (e) => {
    if (e.target.id === id) {
      props.onClose();
    }
  };

  // Escape key handler
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") props.onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <Overlay id={id} onClick={handleOutsideClick}>
      <Sheet role="dialog" aria-modal="true" aria-label="Informacoes da linha">
        <DragHandle />

        <SheetTitle title={props.data.locationsPoint.name}>
          {props.data.locationsPoint.name}
        </SheetTitle>

        <SheetTag title={props.data.locationsPoint.buslineshift.tag}>
          {props.data.locationsPoint.buslineshift.tag}
        </SheetTag>

        {props.data.schedulePoint &&
          props.data.schedulePoint.dev_status.unit_id && (
            <InfoRow>
              <InfoIconBox>
                <Icon.MdDirectionsCar />
              </InfoIconBox>
              <div>
                <InfoLabel>Frota</InfoLabel>
                <InfoValue title={`FROTA: ${props.data.schedulePoint.dev_status.label2}`}>
                  {props.data.schedulePoint.dev_status.label2}
                </InfoValue>
              </div>
            </InfoRow>
          )}

        <InfoRow>
          <InfoIconBox>
            <Icon.MdQueryBuilder />
          </InfoIconBox>
          <div>
            <InfoLabel>Turno</InfoLabel>
            <InfoValue>
              {props.data.locationsPoint.buslineshift.shift.name === null
                ? "Turno nao informado"
                : props.data.locationsPoint.buslineshift.shift.name}
            </InfoValue>
          </div>
        </InfoRow>

        <InfoRow>
          <InfoIconBox style={{ background: '#e6f5df', color: '#1b9e3e' }}>
            <Icon.MdTripOrigin />
          </InfoIconBox>
          <div>
            <InfoLabel>Ponto Inicial</InfoLabel>
            <InfoValue>
              {props.data.locationsPoint.poi && props.data.locationsPoint.poi.length > 0
                ? props.data.locationsPoint.poi[0].name
                : 'Não informado'}
              {' — '}
              {props.data.locationsPoint.poi && props.data.locationsPoint.poi.length > 0
                ? props.data.locationsPoint.poi[0].hour
                : props.data.locationsPoint.buslineshift.hour}
            </InfoValue>
            <InfoSub title={props.data.enderecos && props.data.enderecos[0]}>
              {props.data.enderecos && props.data.enderecos[0]
                ? props.data.enderecos[0]
                : 'Endereço não disponível'}
            </InfoSub>
          </div>
        </InfoRow>

        <InfoRow>
          <InfoIconBox style={{ background: '#f8d7da', color: '#b80000' }}>
            <Icon.MdFlag />
          </InfoIconBox>
          <div>
            <InfoLabel>Ponto Final</InfoLabel>
            <InfoValue>
              {props.data.locationsPoint.poi && props.data.locationsPoint.poi.length > 1
                ? props.data.locationsPoint.poi[props.data.locationsPoint.poi.length - 1].name
                : 'Não informado'}
              {' — '}
              {props.data.locationsPoint.poi && props.data.locationsPoint.poi.length > 1
                ? props.data.locationsPoint.poi[props.data.locationsPoint.poi.length - 1].hour
                : ''}
            </InfoValue>
            <InfoSub title={props.data.enderecos && props.data.enderecos[props.data.enderecos.length - 1]}>
              {props.data.enderecos && props.data.enderecos.length > 1
                ? props.data.enderecos[props.data.enderecos.length - 1]
                : 'Endereço não disponível'}
            </InfoSub>
          </div>
        </InfoRow>

        <InfoRow>
          <InfoIconBox>
            <Icon.MdToday />
          </InfoIconBox>
          <div>
            <InfoLabel>Dias da semana</InfoLabel>
            <WeekdayGrid>
              {props.data.locationsPoint.buslineshift.weekday.map((w, i) => (
                <WeekdayBadge key={i}>{w}</WeekdayBadge>
              ))}
            </WeekdayGrid>
          </div>
        </InfoRow>

        {props.onCenterRoute && (
          <CenterRouteBtn onClick={() => { props.onCenterRoute(); props.onClose(); }}>
            <Icon.MdMyLocation size={18} />
            <span>Centralizar na rota</span>
          </CenterRouteBtn>
        )}
      </Sheet>
    </Overlay>
  );
};

export default ModalInfo;
